// KPI Period Action Creators

import * as actionTypes from './redux.actionTypes';

// Fetch Periods
export const fetchPeriodsRequest = (params) => ({
  type: actionTypes.FETCH_PERIODS_REQUEST,
  payload: params,
});

export const fetchPeriodsSuccess = (data) => ({
  type: actionTypes.FETCH_PERIODS_SUCCESS,
  payload: data,
});

export const fetchPeriodsFailure = (error) => ({
  type: actionTypes.FETCH_PERIODS_FAILURE,
  payload: error,
});

// Fetch Period by ID
export const fetchPeriodByIdRequest = (id) => ({
  type: actionTypes.FETCH_PERIOD_BY_ID_REQUEST,
  payload: id,
});

export const fetchPeriodByIdSuccess = (data) => ({
  type: actionTypes.FETCH_PERIOD_BY_ID_SUCCESS,
  payload: data,
});

export const fetchPeriodByIdFailure = (error) => ({
  type: actionTypes.FETCH_PERIOD_BY_ID_FAILURE,
  payload: error,
});

// Create Period
export const createPeriodRequest = (data) => ({
  type: actionTypes.CREATE_PERIOD_REQUEST,
  payload: data,
});

export const createPeriodSuccess = (data) => ({
  type: actionTypes.CREATE_PERIOD_SUCCESS,
  payload: data,
});

export const createPeriodFailure = (error) => ({
  type: actionTypes.CREATE_PERIOD_FAILURE,
  payload: error,
});

// Update Period
export const updatePeriodRequest = (id, data) => ({
  type: actionTypes.UPDATE_PERIOD_REQUEST,
  payload: { id, data },
});

export const updatePeriodSuccess = (data) => ({
  type: actionTypes.UPDATE_PERIOD_SUCCESS,
  payload: data,
});

export const updatePeriodFailure = (error) => ({
  type: actionTypes.UPDATE_PERIOD_FAILURE,
  payload: error,
});

// Delete Period
export const deletePeriodRequest = (id) => ({
  type: actionTypes.DELETE_PERIOD_REQUEST,
  payload: id,
});

export const deletePeriodSuccess = (id) => ({
  type: actionTypes.DELETE_PERIOD_SUCCESS,
  payload: id,
});

export const deletePeriodFailure = (error) => ({
  type: actionTypes.DELETE_PERIOD_FAILURE,
  payload: error,
});

// Set Filters
export const setPeriodFilters = (filters) => ({
  type: actionTypes.SET_PERIOD_FILTERS,
  payload: filters,
});

// Set Pagination
export const setPeriodPagination = (pagination) => ({
  type: actionTypes.SET_PERIOD_PAGINATION,
  payload: pagination,
});

// Reset State
export const resetPeriodState = () => ({
  type: actionTypes.RESET_PERIOD_STATE,
});
